var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowseUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "browse_users",
    "data-name": "browse users",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1222",
    "data-name": "Group 1222"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_851",
    "data-name": "Rectangle 851",
    width: 44,
    height: 44,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1224",
    "data-name": "Group 1224",
    transform: "translate(3.667 7.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1223",
    "data-name": "Group 1223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M13.333,18.667A7.333,7.333,0,1,0,6,11.333,7.331,7.331,0,0,0,13.333,18.667Zm0-11a3.667,3.667,0,1,1-3.667,3.667A3.677,3.677,0,0,1,13.333,7.667Z",
    transform: "translate(1.333 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M5.667,21.329c.4-1.32,6.068-3.667,11-3.667a10.9,10.9,0,0,1,.642-3.648C12.3,13.831,2,16.324,2,21.329V25H19.49a10.771,10.771,0,0,1-2.182-3.667Z",
    transform: "translate(-2 4.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M25.622,23.037a7.084,7.084,0,0,0,1.045-3.7,7.333,7.333,0,1,0-7.333,7.333,7.258,7.258,0,0,0,3.7-1.045l4.712,4.712,2.585-2.585C27.583,25,28.885,26.282,25.622,23.037ZM19.333,23A3.667,3.667,0,1,1,23,19.333,3.677,3.677,0,0,1,19.333,23Z",
    transform: "translate(6.333 2.667)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseUsers);
export default __webpack_public_path__ + "static/media/browse-users.4aa51692e7fae46f33b117875d9caacb.svg";
export { ForwardRef as ReactComponent };